import {
    BrowseCourseCard,
    BrowseCourseCarousel,
    BrowseCourseCarouselConfiguration,
} from '@udemy-v2/react-browse-course';
import {useDeviceType} from '@udemy-v2/hooks';
import {
    BrowseEventTrackingProvider,
    TrackableDiscoveryItem,
} from '@udemy-v2/react-browse-event-tracking';
import {BrowseCourse} from '@udemy-v2/browse-course';

import {
    DESKTOP_BROWSE_COURSE_CARD_OPTIONS,
    DESKTOP_BROWSE_COURSE_CAROUSEL_CONFIGURATION,
} from './browse-course-carousel-desktop-configuration';
import styles from './browse-course-carousel.module.scss';

interface ResponsiveBrowseCourseCarouselProps<T extends BrowseCourse> {
    courses: TrackableDiscoveryItem<T>[];
    className?: string;
    config?: BrowseCourseCarouselConfiguration;
}

/**
 * CLP adapter around `@udemy-v2/react-browse-course`'s `BrowseCourseCarousel`.
 *
 * Mobile keeps a vertical stack of condensed cards (not achievable via carousel
 * configuration alone). Desktop delegates to the shared carousel with the
 * standard CLP full-width configuration.
 */
export function ResponsiveBrowseCourseCarousel<T extends BrowseCourse>({
    courses,
    className,
    config,
}: ResponsiveBrowseCourseCarouselProps<T>) {
    const deviceType = useDeviceType();

    if (deviceType === 'mobile') {
        return (
            <div className={className}>
                {courses.map((course, index) => (
                    <BrowseEventTrackingProvider
                        key={course.id}
                        browseEventTrackingContext={{index}}
                    >
                        <div className={styles['card-container']}>
                            <BrowseCourseCard
                                course={course}
                                layout="condensed"
                                options={DESKTOP_BROWSE_COURSE_CARD_OPTIONS}
                            />
                        </div>
                    </BrowseEventTrackingProvider>
                ))}
            </div>
        );
    }

    return (
        <BrowseCourseCarousel
            courses={courses}
            className={className ?? styles['margin-top-xs']}
            configuration={config ?? DESKTOP_BROWSE_COURSE_CAROUSEL_CONFIGURATION}
            options={DESKTOP_BROWSE_COURSE_CARD_OPTIONS}
        />
    );
}
